import React from 'react';
import Udesk from 'Udesk';
import { Space, Tabs } from 'udesk-ui';
import { Redirect } from 'react-router-dom';
import Page from 'Component/common/udesk-qa-page-layout';
import SubRoutes from 'udesk-react/src/components/sub-routes';
import { ArrowLeftOutlined } from '@ant-design/icons';
import './style.scss';
import UdeskLocales from 'UdeskLocales';

const { TabPane } = Tabs;

const TemplateManage: React.FC<any> = ({ history, routes, route, location }) => {
    // 获取当前激活的tab
    const getActiveTab = () => {
        if (location.pathname.includes('/dialogue')) {
            return 'dialogueManage';
        }
        return 'roleManage';
    };

    // Tab切换处理
    const handleTabChange = (activeKey: string) => {
        const routeName =
            activeKey === 'roleManage'
                ? 'coachTemplateManageRoleEntry'
                : 'coachTemplateManageDialogueEntry';
        const routeOptions = {
            history: history,
            routeName,
        };
        Udesk.ui.routing.transitionTo(routeOptions);
    };

    // 获取当前页面标题
    const getPageTitle = () => {
        const pathname = location.pathname;

        // 根据路由配置判断当前页面
        if (pathname.includes('/template-manage/role-manage/create')) {
            return /* 新建角色 */UdeskLocales['current'].pages.coach.templateManage.index.newRole;
        }
        if (pathname.includes('/template-manage/role-manage/edit')) {
            return /* 编辑角色 */UdeskLocales['current'].pages.coach.templateManage.index.editRole;
        }
        if (pathname.includes('/template-manage/dialogue-manage/create')) {
            return /* 新建场景 */UdeskLocales['current'].pages.coach.templateManage.index.newScene;
        }
        if (pathname.includes('/template-manage/dialogue-manage/edit')) {
            return /* 编辑场景 */UdeskLocales['current'].pages.coach.templateManage.index.editScene;
        }

        return /* 模板管理 */UdeskLocales['current'].pages.coach.templateManage.index.templateManagement;
    };

    // 判断是否显示返回按钮
    const showBackButton = () => {
        return location.pathname.includes('/create') || location.pathname.includes('/edit');
    };

    // 返回处理
    const handleBack = () => {
        history.goBack();
    };

    // 获取页面头部内容
    const getPageHeader = () => {
        if (showBackButton()) {
            return (
                <Space>
                    <ArrowLeftOutlined onClick={handleBack} />
                    <span>{getPageTitle()}</span>
                </Space>
            );
        }
        return getPageTitle();
    };

    // 获取页面底部内容
    const getPageFooter = () => {
        if (showBackButton()) {
            return null;
        }
        return (
            <Tabs activeKey={getActiveTab()} onChange={handleTabChange}>
                <TabPane tab={/* 角色管理 */UdeskLocales['current'].pages.coach.templateManage.index.roleManagement} key="roleManage" />
                <TabPane tab={/* 场景管理 */UdeskLocales['current'].pages.coach.templateManage.index.sceneManagement} key="dialogueManage" />
            </Tabs>
        );
    };

    // 如果访问根路径，重定向到角色管理
    if (location.pathname === route.path) {
        const toPath = Udesk.ui.routing.getRouteFirstBottomedChildRoutePath({
            routeName: route.name,
        });
        return <Redirect to={toPath} />;
    }

    return (
        <div className="coach-template-manage-page">
            <Page
                title={getPageHeader()}
                pageBodyClassName="coach-template-manage"
                footer={getPageFooter()}
                backGroundGhost={true}
            >
                <div className="template-manage-content">
                    {routes.map((route) => (
                        <SubRoutes key={route.name} route={route} />
                    ))}
                </div>
            </Page>
        </div>
    );
};

export default TemplateManage;
